import React from 'react';
import { Plus, Minus, Circle } from 'lucide-react';
import { getTimelineData, formatTimelineDate, getTimelinePosition } from '../../utils/timelineUtils';

const Timeline = ({ messages, studentName, selectedCategory, onEntryClick }) => {
  const timelineData = getTimelineData(messages, studentName, selectedCategory);
  
  const handleTimelineClick = (entry) => {
    onEntryClick(entry.id);
  };

  if (timelineData.length === 0) {
    return <div className="text-center text-gray-500 py-4">No entries found</div>;
  }

  const firstDate = timelineData[0]?.timestamp;
  const lastDate = timelineData[timelineData.length - 1]?.timestamp;

  return (
    <div className="w-full py-4 px-8">
      <div className="relative h-[60px]">
        {/* Timeline line */}
        <div 
          className="absolute h-[2px] bg-gray-200 left-0 right-0 top-1/2" 
        />

        {/* Timeline points */}
        {timelineData.map((entry) => {
          const verticalOffset = entry.sentiment === 'positive' ? -20 :
                               entry.sentiment === 'negative' ? 20 : 0;
          
          return (
            <button
              key={entry.id}
              onClick={() => handleTimelineClick(entry)}
              style={{ 
                position: 'absolute',
                left: `${getTimelinePosition(entry.timestamp, firstDate, lastDate)}%`,
                top: '50%',
                transform: `translate(-50%, calc(${verticalOffset}px - 10px))`,
              }}
              className="hover:scale-110 transition-transform z-10"
              title={`${formatTimelineDate(entry.timestamp)}: ${entry.text.substring(0, 50)}...`}
            >
              <div className="bg-white">
                {entry.sentiment === 'positive' && (
                  <Plus className="text-green-500" size={20} />
                )}
                {entry.sentiment === 'negative' && (
                  <Minus className="text-orange-500" size={20} />
                )}
                {entry.sentiment === 'neutral' && (
                  <Circle className="text-gray-400" size={20} />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;